import { render, staticRenderFns } from "./CategoryEmpty.vue?vue&type=template&id=2299a4af&"
import script from "./CategoryEmpty.vue?vue&type=script&lang=ts&"
export * from "./CategoryEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports